import React from "react";
import PageMeta from "./PageMeta";
import PublicPageLayout from "./PublicPageLayout";

const contactCards = [
  {
    title: "General Inquiries",
    body: "Questions about the platform, partnerships, or setup help.",
    action: "mailto:contact@tenantdispatch.com?subject=General%20Inquiry",
    label: "contact@tenantdispatch.com"
  },
  {
    title: "Sales",
    body: "Talk with us about portfolio fit, pricing, and onboarding.",
    action: "mailto:contact@tenantdispatch.com?subject=Sales%20Inquiry",
    label: "Request a demo"
  },
  {
    title: "Support",
    body: "Need help with an account or maintenance workflow issue.",
    action: "mailto:contact@tenantdispatch.com?subject=Support%20Request",
    label: "Get support"
  }
];

const ContactPage = () => {
  return (
    <PublicPageLayout
      eyebrow="Contact"
      title="Get in Touch"
      intro="Whether you want a demo, support, or a quick answer before signing up, we can help. Email is the fastest way to reach the Tenant Dispatch team."
    >
      <PageMeta
        title="Contact Tenant Dispatch"
        description="Contact Tenant Dispatch for sales questions, support, demos, and general inquiries."
        canonical="https://tenantdispatch.com/contact"
      />

      <div className="public-page-prose">
        <p>We aim to respond to most inquiries within one business day.</p>
      </div>

      <div className="public-contact-grid">
        {contactCards.map((card) => (
          <a key={card.title} className="public-contact-card" href={card.action}>
            <h2>{card.title}</h2>
            <p>{card.body}</p>
            <span>{card.label}</span>
          </a>
        ))}
      </div>
    </PublicPageLayout>
  );
};

export default ContactPage;
